import { z } from 'zod'

/**
 * Where a client sits in the funnel. Mirrors `ClientStatus` in
 * prisma/schema.prisma.
 *
 * Deliberately coarse. A conventional CRM would model this as a separate
 * Lead/Opportunity pipeline, but for a proposal-driven business the proposal
 * itself carries the pursuit — so the client only needs to say whether they
 * have ever bought from us.
 */
export const CLIENT_STATUSES = ['PROSPECT', 'ACTIVE', 'INACTIVE'] as const

export const clientStatusSchema = z.enum(CLIENT_STATUSES)

export type ClientStatus = z.infer<typeof clientStatusSchema>

export const CLIENT_STATUS_LABELS: Record<ClientStatus, string> = {
  PROSPECT: 'Prospect',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
}
